import { Charge, Probe } from "@/pages/heat-report/models/HeatReportModels";
import { ManualAutoButton } from "@/shared/data-entries/ManualAutoButton";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Charges",
      children: [
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) => {
            if (params.data?.Timestamp) {
              return dxtToLocalServerTime(
                (params.data as Charge).Timestamp,
                "HH:mm",
              );
            }
          },
        },
        {
          field: "BucketName",
          headerName: "Bucket",
          flex: 2,
        },
        {
          field: "Weight",
          headerName: "Weight [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) =>
            params.data?.Weight?.toFixed(0) || "0",
        },
        {
          field: "Lime",
          headerName: "Lime [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) =>
            params.data?.Lime?.toFixed(0) || "0",
        },
      ],
    },
  ];

  return { columns };
};
